// extracted by mini-css-extract-plugin
module.exports = {"commonWrapper":"AuthCheckStub__commonWrapper___uQGq-","textWrapper":"AuthCheckStub__textWrapper___u-6e9"};